import { loadable } from '@shared/core/loadableFromNamedExport';

// Cannot change the chunk name here because it is used in the bookmarklet script
export const LazyBookmarklet = loadable(() => import(/* webpackChunkName: "registry/admin/routes/Bookmarklet" */ './BookmarkletNav'), 'BookmarkletNav');
